import React from "react";

import {
  CheckboxGroupProps,
  useCheckboxGroup,
  Stack,
  Tag,
} from "@chakra-ui/react";

import { Option } from "../../../types";

import CheckboxCard from "./CheckboxCard";

import useTranslations from "../../../hooks/useTranslations";

type CheckboxCardGroupProps = Omit<CheckboxGroupProps, "children"> & {
  name?: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  options: Option[];
};

const CheckboxCardGroup = React.forwardRef<
  HTMLInputElement,
  CheckboxCardGroupProps
>(({ isDisabled = false, ...props }, ref) => {
  const t = useTranslations();
  const { getCheckboxProps } = useCheckboxGroup({
    ...props,
  });

  return (
    <Stack spacing="3" w="full">
      {props.options.map(({ label, value, isGoal }, index) => {
        const checkbox = getCheckboxProps({ value } as any);

        return (
          <CheckboxCard
            key={value}
            index={index}
            ref={ref}
            isFocusable={!isDisabled}
            isDisabled={isDisabled}
            isInvalid={props.isInvalid}
            name={props?.name}
            tag={isGoal ? <Tag>{t("reviews.targetLevel")}</Tag> : undefined}
            {...checkbox}
          >
            {label}
          </CheckboxCard>
        );
      })}
    </Stack>
  );
});

export default CheckboxCardGroup;
